// services/chatbotService.js
import axios from "axios";

const apiUrl = process.env.VUE_APP_MICROSERVICE_API_URL;

export async function fetchChatbots(userId) {
  try {
    const response = await axios.get(`${apiUrl}/users/${userId}/chatbots`);
    const chatbots = response.data;

    if (chatbots.length > 0) {
      localStorage.setItem("chatbotRecords", JSON.stringify(chatbots));
    } else {
      localStorage.removeItem("chatbotRecords");
    }

    return chatbots;
  } catch (error) {
    console.error("Error fetching chatbots:", error);
    localStorage.removeItem("chatbotRecords");
    throw error; // Rethrow the error for handling in components.
  }
}
